import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-brand-dark">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center text-brand-gold hover:text-yellow-400 mb-8">
          <ArrowLeft size={20} className="mr-2" /> Back to Home
        </Link>
        
        <div className="glass-card rounded-2xl p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-brand-gold mb-2">Privacy Policy</h1>
          <p className="text-gray-400 mb-8">Effective Date: January 1, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-8">
              This policy explains how ECSA (Economic Club of San Antonio) collects, uses, and shares information.
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">1) Information We Collect</h2>
              <p className="text-gray-300">
                We may collect: name, email, phone, business and role/title, profile details you provide (bio/headshot/social links), event RSVPs and attendance, communications with ECSA, and standard website data (IP, device, cookies/analytics). Payments are processed by third-party processors; we may receive confirmation and limited billing details.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">2) How We Use Information</h2>
              <p className="text-gray-300">
                We use information to operate membership and events, provide directories/networking features, communicate updates, improve the site/programming, prevent misuse, and enforce our Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">3) Member-to-Member Visibility</h2>
              <p className="text-gray-300">
                Information you submit in member profiles, directories, posts, event rosters, and networking features may be visible to other members. Do not share confidential or sensitive information you don't want shared.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">4) Sharing with Sponsors, Affiliates, and Third Parties</h2>
              <div className="p-4 rounded-xl bg-brand-gold/10 border border-brand-gold/30 mb-4">
                <p className="text-brand-gold font-semibold mb-2">Key Notice</p>
              </div>
              <p className="text-gray-300 mb-4">
                ECSA may share and/or allow use of member-submitted information—including information visible to or shared among members—by third-party affiliates and sponsors for purposes such as:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Event administration and co-hosting</li>
                <li>Member benefits/discounts and partner programming</li>
                <li>Sponsor/affiliate outreach and offers</li>
                <li>Reporting and analytics to support ECSA operations and growth</li>
              </ul>
              <p className="text-gray-300 mt-4">
                Where feasible, we will provide opt-out options for sponsor/affiliate marketing outreach. Operational sharing needed to deliver services (e.g., attendee lists for check-in) may not be optional.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">5) Service Providers</h2>
              <p className="text-gray-300">
                We use vendors (CRM, email, analytics, event platforms) to process data on our behalf for business purposes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">6) Cookies & Analytics</h2>
              <p className="text-gray-300">
                We use cookies/analytics to run and improve the website. You can adjust browser settings, but some features may not work.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">7) Security & Retention</h2>
              <p className="text-gray-300">
                We use reasonable safeguards. No system is fully secure. We retain data as needed for operations, legal compliance, and enforcement, then delete or de-identify when practicable.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">8) Your Choices</h2>
              <p className="text-gray-300">
                You may request access, correction, or deletion where applicable, and opt out of certain communications.
              </p>
              <p className="text-gray-300 mt-4">
                <strong className="text-white">Contact:</strong> Mauricio Sanchez, <a href="mailto:mau@mausanchez.com" className="text-brand-gold hover:underline">mau@mausanchez.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-brand-gold mb-4">9) Updates</h2>
              <p className="text-gray-300">
                We may update this policy and will post the revised Effective Date.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
